.RtrReadyWrapper
    all: initial
    font-family: $globalSettingsFontFamily